<template>
	<div style="overflow: auto">
		<div class="mb-4">
			<input type="text" v-model="search" class="form-control form-control-lg shadow-sm" placeholder="Cerca assistito o Codice..." />
		</div>
		<div v-for="pratica in praticheFiltrate" :key="pratica.pr_id" class="card sa-siat-card-pratica shadow-sm">
			<div class="sa-siat-card-header-custom">
				<b-row>
					<b-col cols="12" md="4">
						<div class="sa-siat-label-pai">Pratica</div>
						<small style="font-size: 1rem; color: #07077d; font-weight: bold">#{{ pratica.pr_id }}</small>
					</b-col>
					<b-col cols="12" md="4">
						<div class="sa-siat-label-pai">Stato</div>
						<span class="badge badge-pill badge-light border sa-siat-badge" :class="'sa-siat-badge-' + pratica.stato.toLowerCase()">{{ pratica.stato }}</span>
					</b-col>
					<b-col cols="12" md="4">
						<div class="sa-siat-label-pai">Bisogno</div>
						<span class="sa-siat-data" :class="'sa-siat-data-' + bisogno(pratica)">{{ pratica.bisogno }}</span>
					</b-col>
				</b-row>
				<div class="row align-items-center">
					<div class="col-md-4">
						<div class="sa-siat-label-pai">Assistito</div>
						<div class="h5 mb-0 text-primary">{{ pratica.assistito.cognome }} {{ pratica.assistito.nome }}</div>
						<small class="text-muted sa-siat-text-indirizzo"><i class="fas fa-map-marker-alt"></i> {{ pratica.assistito.indirizzoDiResidenza }}</small>
					</div>
					<div class="col-md-4">
						<div class="sa-siat-label-pai">Codice Fiscale</div>
						<span class="sa-siat-data">{{ pratica.assistito.codiceFiscale }}</span>
					</div>
					<div class="col-md-4">
						<div class="sa-siat-label-pai">Distretto / Stato</div>
						<div>{{ pratica.distretto.code }} - {{ pratica.distretto.descrizione }}</div>
					</div>
				</div>
			</div>

			<div class="pb-3 pt-2 bg-light">
				<div class="px-4 mb-2 small font-weight-bold text-muted text-uppercase">Elenco Prestazioni Attive:</div>

				<template v-for="pac in pratica.pacchettoAssistenziale">
					<div v-for="ev in pac.evento" :key="ev.id">
						<b-row class="sa-siat-row">
							<b-col class="sa-siat-cols" cols="12" md="3">
								<div class="sa-siat-label-pai">Id Evento</div>
								<div class="sa-siat-valore-pai">{{ ev.id }}</div>
							</b-col>
							<b-col class="sa-siat-cols" cols="12" md="6">
								<b-alert v-if="ev.presaInCarico" variant="success" show class="mb-0 py-1 shadow-sm"> <i class="fas fa-check-circle mr-1"></i> Presa in carico OK </b-alert>

								<b-alert v-if="ev.errorePresa" variant="danger" show class="mb-0 py-1 shadow-sm"> <i class="fas fa-exclamation-circle mr-1"></i> {{ ev.errorePresa }} </b-alert>
							</b-col>
							<b-col class="sa-siat-cols text-right" cols="12" md="3">
								<button class="btn btn-primary btn-presa shadow-sm" @click.stop="effettuaPresa(ev)"><i class="fas fa-hand-holding-medical mr-1"></i> Presa in Carico</button>
								<!-- <button v-else class="btn btn-success btn-presa" disabled><i class="fas fa-check mr-1"></i> In Carico</button> -->
							</b-col>
						</b-row>
						<div v-for="pres in ev.prestazione" :key="pres.pi_id" class="sa-siat-prestazione-item shadow-xs" :class="'sa-siat-border-' + pres.figuraProfessionale.ra_cod">
							<div class="sa-siat-prestazione-header" @click="togglePrestazione(pres.pi_id)">
								<div>
									<span class="badge badge-outline-secondary mr-2">{{ pres.figuraProfessionale.ra_cod }}</span>
									<strong>{{ pres.tipoPrestazione }}</strong>
								</div>
								<i class="fas text-muted" :class="isPresOpen(pres.pi_id) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
							</div>

							<div v-if="isPresOpen(pres.pi_id)" class="prestazione-detail">
								<b-row class="sa-siat-row">
									<b-col class="sa-siat-cols" cols="12" md="3">
										<div class="sa-siat-label-pai">Codice PAI</div>
										<div class="sa-siat-valore-pai">{{ pres.po_id }}</div>
									</b-col>
									<b-col class="sa-siat-cols" cols="12" md="3">
										<div class="sa-siat-label-pai">Data Inizio Intervento</div>
										<div class="sa-siat-valore-pai"><i class="far fa-calendar-alt mr-1"></i> {{ pulisciData(pres.dataInizioInterventi) }}</div>
									</b-col>
									<b-col class="sa-siat-cols" cols="12" md="3">
										<div class="sa-siat-label-pai">Frequenza Pianificata</div>
										<div class="sa-siat-valore-pai">
											<i class="fas fa-history mr-1 text-info"></i>
											<template v-if="pres.frequenza"> {{ pres.frequenza.numeroInterventi }} int. / {{ pres.frequenza.numeroRipetizioni }} {{ pres.frequenza.utNumeroRipetizioni }} </template>
											<template v-else-if="pres.frequenzaVolte"> {{ pres.frequenzaVolte.numeroVolte }} volte in {{ pres.frequenzaVolte.numeroGiorni }} gg </template>
										</div>
									</b-col>
									<b-col class="sa-siat-cols" cols="12" md="3">
										<div class="sa-siat-label-pai">Figura Profezzionale</div>
										<div class="sa-siat-valore-pai" :class="'sa-siat-text-' + pres.figuraProfessionale.ra_cod">{{ pres.figuraProfessionale.value }}</div>
									</b-col>
								</b-row>
								<b-row class="mt-4">
									<b-col class="sa-siat-cols" cols="12">
										<div class="sa-siat-label-pai">Descrizione Estesa</div>
										<div class="italic sa-siat-text-data">{{ pres.tipoPrestazione }} - {{ pac.pacchettoDescrizione }}</div>
									</b-col>
								</b-row>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import SiatMixin from "../mixins/SiatMixin";
export default {
	mixins: [SiatMixin],
	data() {
		return {
			// pratiche: [
			// 	{
			// 		pr_id: "1600037",
			// 		stato: "Aperta",
			// 		assistito: { cognome: "PROVA", nome: "CHIARA", codiceFiscale: "PRVCHR90T71A123N", indirizzoDiResidenza: "Via Prova, 15 - Sora (FR)" },
			// 		distretto: { code: "FR3", descrizione: "Sora" },
			// 		pacchettiAssistenziali: [
			// 			{
			// 				pacchettoDescrizione: "ACCESSO",
			// 				eventi: [
			// 					{
			// 						prestazioni: [
			// 							{
			// 								pi_id: "P1",
			// 								po_id: "13333579",
			// 								tipoPrestazione: "PRELIEVO EMATICO",
			// 								figuraProfessionale: { ra_cod: "IP", valore: "INFERMIERE" },
			// 								frequenza: { numeroInterventi: 1, numeroRipetizioni: 4, utNumeroRipetizioni: "giorno/i" },
			// 								dataInizioInterventi: "2026-01-19",
			// 							},
			// 							{
			// 								pi_id: "P2",
			// 								po_id: "13333580",
			// 								tipoPrestazione: "EDUCAZIONE CARE GIVER",
			// 								figuraProfessionale: { ra_cod: "FISIO", valore: "FISIOTERAPISTA" },
			// 								frequenza: { numeroInterventi: 1, numeroRipetizioni: 1, utNumeroRipetizioni: "settimana" },
			// 								dataInizioInterventi: "2026-01-20",
			// 							},
			// 						],
			// 					},
			// 				],
			// 			},
			// 		],
			// 	},
			// 	{
			// 		pr_id: "1600038",
			// 		stato: "Aperta",
			// 		assistito: { cognome: "ROSSI", nome: "MARIO", codiceFiscale: "RSSMRA55E20H501U", indirizzoDiResidenza: "Via Roma, 120 - Alatri (FR)" },
			// 		distretto: { code: "FR1", descrizione: "Alatri" },
			// 		pacchettiAssistenziali: [
			// 			{
			// 				pacchettoDescrizione: "ADI BASE",
			// 				eventi: [
			// 					{
			// 						prestazioni: [
			// 							{
			// 								pi_id: "P3",
			// 								po_id: "13334000",
			// 								tipoPrestazione: "IGIENE PERSONALE",
			// 								figuraProfessionale: { ra_cod: "OSS", valore: "OPERATORE SOCIO SANITARIO" },
			// 								frequenza: { numeroInterventi: 3, numeroRipetizioni: 1, utNumeroRipetizioni: "settimana" },
			// 								dataInizioInterventi: "2026-02-01",
			// 							},
			// 						],
			// 					},
			// 				],
			// 			},
			// 		],
			// 	},
			// 	{
			// 		pr_id: "1600039",
			// 		stato: "Sospesa",
			// 		assistito: { cognome: "BIANCHI", nome: "LUIGI", codiceFiscale: "BNCLGU48M20F205Z", indirizzoDiResidenza: "Corso Italia, 5 - Cassino (FR)" },
			// 		distretto: { code: "FR4", descrizione: "Cassino" },
			// 		pacchettiAssistenziali: [
			// 			{
			// 				pacchettoDescrizione: "RIABILITAZIONE",
			// 				eventi: [
			// 					{
			// 						prestazioni: [{ pi_id: "P4", po_id: "13335000", tipoPrestazione: "KINESITERAPIA", figuraProfessionale: { ra_cod: "FISIO", valore: "FISIOTERAPISTA" }, frequenzaVolte: { numeroVolte: 10, numeroGiorni: 20 }, dataInizioInterventi: "2026-01-15" }],
			// 					},
			// 				],
			// 			},
			// 		],
			// 	},
			// 	{
			// 		pr_id: "1600040",
			// 		stato: "Aperta",
			// 		assistito: { cognome: "VERDI", nome: "GIUSEPPE", codiceFiscale: "VRDGPP62R15G273E", indirizzoDiResidenza: "Via Napoli, 44 - Anagni (FR)" },
			// 		distretto: { code: "FR1", descrizione: "Anagni" },
			// 		pacchettiAssistenziali: [
			// 			{
			// 				pacchettoDescrizione: "CURE PALLIATIVE",
			// 				eventi: [
			// 					{
			// 						prestazioni: [
			// 							{
			// 								pi_id: "P5",
			// 								po_id: "13336000",
			// 								tipoPrestazione: "TERAPIA DEL DOLORE",
			// 								figuraProfessionale: { ra_cod: "MED", valore: "MEDICO" },
			// 								frequenza: { numeroInterventi: 1, numeroRipetizioni: 1, utNumeroRipetizioni: "giorno/i" },
			// 								dataInizioInterventi: "2026-02-10",
			// 							},
			// 							{
			// 								pi_id: "P6",
			// 								po_id: "13336001",
			// 								tipoPrestazione: "SUPPORTO PSICOLOGICO",
			// 								figuraProfessionale: { ra_cod: "PSIC", valore: "PSICOLOGO" },
			// 								frequenza: { numeroInterventi: 1, numeroRipetizioni: 1, utNumeroRipetizioni: "settimana" },
			// 								dataInizioInterventi: "2026-02-12",
			// 							},
			// 						],
			// 					},
			// 				],
			// 			},
			// 		],
			// 	},
			// 	{
			// 		pr_id: "1600041",
			// 		stato: "Aperta",
			// 		assistito: { cognome: "ESPOSITO", nome: "ANNA", codiceFiscale: "SPSNNA70C41F839K", indirizzoDiResidenza: "Via Vitruvio, 8 - Formia (LT)" },
			// 		distretto: { code: "FR3", descrizione: "Sora" },
			// 		pacchettiAssistenziali: [
			// 			{
			// 				pacchettoDescrizione: "MEDICAZIONI",
			// 				eventi: [
			// 					{
			// 						prestazioni: [{ pi_id: "P7", po_id: "13337000", tipoPrestazione: "BENDAGGIO ELASTOCOMPRESSIVO", figuraProfessionale: { ra_cod: "IP", valore: "INFERMIERE" }, frequenzaVolte: { numeroVolte: 2, numeroGiorni: 7 }, dataInizioInterventi: "2026-02-05" }],
			// 					},
			// 				],
			// 			},
			// 		],
			// 	},
			// 	{
			// 		pr_id: "1600042",
			// 		stato: "Chiusa",
			// 		assistito: { cognome: "FERRARI", nome: "FRANCO", codiceFiscale: "FRRFNC40A01L219G", indirizzoDiResidenza: "Piazza Libertà, 1 - Frosinone (FR)" },
			// 		distretto: { code: "FR2", descrizione: "Frosinone" },
			// 		pacchettiAssistenziali: [
			// 			{
			// 				pacchettoDescrizione: "POST-OPERATORIO",
			// 				eventi: [
			// 					{
			// 						prestazioni: [
			// 							{
			// 								pi_id: "P8",
			// 								po_id: "13338000",
			// 								tipoPrestazione: "GESTIONE CATETERE",
			// 								figuraProfessionale: { ra_cod: "IP", valore: "INFERMIERE" },
			// 								frequenza: { numeroInterventi: 1, numeroRipetizioni: 15, utNumeroRipetizioni: "giorno/i" },
			// 								dataInizioInterventi: "2026-01-01",
			// 							},
			// 						],
			// 					},
			// 				],
			// 			},
			// 		],
			// 	},
			// 	{
			// 		pr_id: "1600043",
			// 		stato: "Aperta",
			// 		assistito: { cognome: "GATTI", nome: "MARIA", codiceFiscale: "GTTMRA65S45H501V", indirizzoDiResidenza: "Via dei Fiori, 3 - Ceccano (FR)" },
			// 		distretto: { code: "FR2", descrizione: "Frosinone" },
			// 		pacchettiAssistenziali: [
			// 			{
			// 				pacchettoDescrizione: "RECUPERO MOTORIO",
			// 				eventi: [
			// 					{
			// 						prestazioni: [
			// 							{
			// 								pi_id: "P9",
			// 								po_id: "13339000",
			// 								tipoPrestazione: "RIEDUCAZIONE NEUROMOTORIA",
			// 								figuraProfessionale: { ra_cod: "FISIO", valore: "FISIOTERAPISTA" },
			// 								frequenza: { numeroInterventi: 2, numeroRipetizioni: 1, utNumeroRipetizioni: "settimana" },
			// 								dataInizioInterventi: "2026-02-10",
			// 							},
			// 						],
			// 					},
			// 				],
			// 			},
			// 		],
			// 	},
			// 	{
			// 		pr_id: "1600044",
			// 		stato: "Aperta",
			// 		assistito: { cognome: "RICCI", nome: "ELENA", codiceFiscale: "RCCLNE82P52A123Q", indirizzoDiResidenza: "Via Garibaldi, 20 - Sora (FR)" },
			// 		distretto: { code: "FR3", descrizione: "Sora" },
			// 		pacchettiAssistenziali: [
			// 			{
			// 				pacchettoDescrizione: "SUPPORTO OSS",
			// 				eventi: [
			// 					{
			// 						prestazioni: [
			// 							{
			// 								pi_id: "P10",
			// 								po_id: "13340000",
			// 								tipoPrestazione: "AIUTO ALLA MOBILIZZAZIONE",
			// 								figuraProfessionale: { ra_cod: "OSS", valore: "OPERATORE SOCIO SANITARIO" },
			// 								frequenza: { numeroInterventi: 5, numeroRipetizioni: 1, utNumeroRipetizioni: "settimana" },
			// 								dataInizioInterventi: "2026-02-12",
			// 							},
			// 						],
			// 					},
			// 				],
			// 			},
			// 		],
			// 	},
			// 	{
			// 		pr_id: "1600045",
			// 		stato: "Sospesa",
			// 		assistito: { cognome: "MORETTI", nome: "ALESSANDRO", codiceFiscale: "MRTLSN75H10A123R", indirizzoDiResidenza: "Via Latina, 55 - Frosinone (FR)" },
			// 		distretto: { code: "FR2", descrizione: "Frosinone" },
			// 		pacchettiAssistenziali: [
			// 			{
			// 				pacchettoDescrizione: "CURE COMPLESSE",
			// 				eventi: [
			// 					{
			// 						prestazioni: [
			// 							{
			// 								pi_id: "P11",
			// 								po_id: "13341000",
			// 								tipoPrestazione: "GESTIONE SNG",
			// 								figuraProfessionale: { ra_cod: "IP", valore: "INFERMIERE" },
			// 								frequenza: { numeroInterventi: 1, numeroRipetizioni: 1, utNumeroRipetizioni: "giorno/i" },
			// 								dataInizioInterventi: "2026-01-30",
			// 							},
			// 						],
			// 					},
			// 				],
			// 			},
			// 		],
			// 	},
			// 	{
			// 		pr_id: "1600046",
			// 		stato: "Aperta",
			// 		assistito: { cognome: "GENTILE", nome: "ROBERTO", codiceFiscale: "GNTRRT58B12C123T", indirizzoDiResidenza: "Corso Volsci, 100 - Sora (FR)" },
			// 		distretto: { code: "FR3", descrizione: "Sora" },
			// 		pacchettiAssistenziali: [
			// 			{
			// 				pacchettoDescrizione: "FISIO RESPIRATORIA",
			// 				eventi: [
			// 					{
			// 						prestazioni: [
			// 							{
			// 								pi_id: "P12",
			// 								po_id: "13342000",
			// 								tipoPrestazione: "GINNASTICA RESPIRATORIA",
			// 								figuraProfessionale: { ra_cod: "FISIO", valore: "FISIOTERAPISTA" },
			// 								frequenza: { numeroInterventi: 3, numeroRipetizioni: 1, utNumeroRipetizioni: "settimana" },
			// 								dataInizioInterventi: "2026-02-01",
			// 							},
			// 						],
			// 					},
			// 				],
			// 			},
			// 		],
			// 	},
			// 	{
			// 		pr_id: "1600047",
			// 		stato: "Aperta",
			// 		assistito: { cognome: "VITALE", nome: "STEFANIA", codiceFiscale: "VTLSTF66M41G273F", indirizzoDiResidenza: "Via Casilina, 10 - Anagni (FR)" },
			// 		distretto: { code: "FR1", descrizione: "Anagni" },
			// 		pacchettiAssistenziali: [
			// 			{
			// 				pacchettoDescrizione: "SCREENING ADI",
			// 				eventi: [
			// 					{
			// 						prestazioni: [
			// 							{
			// 								pi_id: "P13",
			// 								po_id: "13343000",
			// 								tipoPrestazione: "VALUTAZIONE MULTIDIMENSIONALE",
			// 								figuraProfessionale: { ra_cod: "MED", valore: "MEDICO" },
			// 								frequenza: { numeroInterventi: 1, numeroRipetizioni: 1, utNumeroRipetizioni: "anno" },
			// 								dataInizioInterventi: "2026-02-12",
			// 							},
			// 						],
			// 					},
			// 				],
			// 			},
			// 		],
			// 	},
			// ],
		};
	},
	computed: {
		praticheFiltrate() {
			return this.pratiche.filter((p) => p.assistito.cognome.toLowerCase().includes(this.search.toLowerCase()) || p.assistito.codiceFiscale.toLowerCase().includes(this.search.toLowerCase()));
		},
	},
	methods: {
		bisogno(pratica) {
			return pratica?.bisogno?.toLowerCase();
		},
		loadData() {
			this.siatLoadLetturaPianiScelta();
		},
		togglePrestazione(pi_id) {
			const index = this.openPrestazioni.indexOf(pi_id);
			if (index > -1) {
				this.openPrestazioni.splice(index, 1);
			} else {
				this.openPrestazioni.push(pi_id);
			}
		},
		isPresOpen(pi_id) {
			return this.openPrestazioni.includes(pi_id);
		},
		pulisciData(d) {
			return d ? d.split("+")[0] : "-";
		},
		effettuaPresa(item) {
			this.siatConfermaLettura(item);
		},
	},
};
</script>

<style scoped>
/* Card Pratica */
.sa-siat-card-pratica {
	border: none;
	border-radius: 12px;
	margin-bottom: 25px;
	overflow: hidden;
}
.sa-siat-card-header-custom {
	background: #fff;
	border-bottom: 1px solid #edf2f7;
	padding: 15px 20px;
}

/* Sezione Prestazioni */
.sa-siat-prestazione-item {
	border: 1px solid #e2e8f0;
	margin: 8px 20px;
	border-radius: 8px;
	background: #fff;
	transition: all 0.2s ease;
}
.sa-siat-prestazione-header {
	padding: 12px 15px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.sa-siat-prestazione-header:hover {
	background: #f8fafc;
}
/* Colori per Figura */
.sa-siat-border-IP {
	border-left: 5px solid #3498db;
}
.sa-siat-border-FISIO {
	border-left: 5px solid #2ecc71;
}
.sa-siat-border-OSS {
	border-left: 5px solid #e67e22;
}
.sa-siat-border-PSIC {
	border-left: 5px solid #9b59b6;
}
.sa-siat-border-MED {
	border-left: 5px solid #e74c3c;
}

.sa-siat-text-IP {
	color: #3498db !important;
}
.sa-siat-text-FISIO {
	color: #2ecc71 !important;
}
.sa-siat-text-OSS {
	color: #e67e22 !important;
}
.sa-siat-text-PSIC {
	color: #9b59b6 !important;
}
.sa-siat-text-MED {
	color: #e74c3c !important;
}

.sa-siat-label-pai {
	font-weight: bold;
	color: #7f8c8d;
	text-transform: uppercase;
	font-size: 0.95rem;
}
.sa-siat-valore-pai {
	color: #2c3e50;
	font-weight: 600;
}
.sa-siat-row {
}
.sa-siat-cols {
	padding-right: 25px;
	padding-left: 25px;
}
.sa-siat-text-data {
	color: #c20000;
}
.sa-siat-text-indirizzo {
	font-size: 1rem;
}
.sa-siat-data {
	color: #e83e8c;
}
.sa-siat-badge {
	display: block;
	font-size: 1rem;
	max-width: 125px;
}
.sa-siat-badge-aperta {
	color: #07af07;
}
.sa-siat-data-complesso {
	color: #e67e22;
}
</style>
